module.exports = __webpack_public_path__ + "img/manifold.7e4ed14f.svg";